/*
 * @Author: masonzhou
 * @Date: 2024-01-19 09:15:57
 * @LastEditTime: 2024-08-30 16:05:56
 * @FilePath: \yl-cjsph-tms-operation-front\src\store\modules\user.ts
 * @Description:
 */
import { defineStore } from 'pinia';
import { store } from '@/store';
import { routerArrays } from '@/layout/types';
import { resetRouter } from '@/router';
import { getLogin } from '@/api/user';
import { useMultiTagsStoreHook } from '@/store/modules/multiTags';
import { setToken, removeToken } from '@/utils/auth';
import { usePermissionStoreHook } from '@/store/modules/permission';

// import { userInfoData } from '@/mock';

export const useUserStore = defineStore({
  id: 'pure-user',
  state: (): {
    userData: any;
    roles: any[];
    username: string;
    roleType: Number;
    pricePermission: Number;
  } => ({
    // 用户名
    username: '',
    // 页面级别权限
    roles: [],
    userData: JSON.parse(localStorage.getItem('userData')) || {},
    roleType: 2,
    pricePermission: null
  }),
  actions: {
    /** 存储用户名 */
    SET_USERNAME(username: string) {
      this.username = username;
    },
    /** 存储角色 */
    SET_ROLES(roles: Array<string>) {
      this.roles = roles;
    },
    // 存储用户信息
    handleUserData(data: any[]) {
      this.userData = data;
      localStorage.setItem('userData', JSON.stringify(data));
    },
    /** 登入 */
    async loginByUsername(reqData: object) {
      return new Promise((resolve, reject) => {
        getLogin(reqData)
          .then(res => {
            if (res) {
              setToken(res.data.authToken, reqData);
              this.handleUserData(res.data);
              resolve(res);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    SET_ROLETYPE(roleType: Number) {
      this.roleType = roleType;
    },
    /** 前端登出（不调用接口） */
    logOut() {
      this.username = '';
      this.userData = '';
      this.roles = [];
      removeToken();
      usePermissionStoreHook().clearAllCachePage();
      useMultiTagsStoreHook().handleTags('equal', [...routerArrays]);
      resetRouter();
      // router.push('/login');
      // window.location.reload();
      window.location.href = window.location.origin + '/login';
    },
    /** 存储用户是否可以查看承运价格、运费价格 */
    SET_PRICE_PERMISSION(pricePermission: Number) {
      console.log('SET_PRICE_PERMISSION', pricePermission);
      this.pricePermission = pricePermission;
    }
  }
});

export function useUserStoreHook() {
  return useUserStore(store);
}
